module.exports = __webpack_public_path__ + "img/ring_r_l_1_0.9a359e8c.png";